import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import SwitchButton from 'LuxKit/Switch/SwitchButton'
import { CALENDAR_GA_EVENT_ACTION, CALENDAR_GA_EVENT_LABEL } from 'constants/analytics'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import UserAnalyticsActionContext from 'contexts/userAnalyticsActionContext'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import type { ChangeEventHandler } from 'react'
import { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  flights: boolean
}

function OfferCalendarFlightsToggle(props: Props) {
  const intl = useIntl()
  const { flights } = props
  const onUserAnalyticsAction = useContext(UserAnalyticsActionContext)
  const dispatch = useOfferPageDispatch()

  const handleChange = useCallback<ChangeEventHandler<HTMLInputElement>>((event) => {
    const isHotelFlightsActive = event.currentTarget.checked
    dispatch({ type: OfferPageActions.setFlights, flights: isHotelFlightsActive })
    onUserAnalyticsAction?.(
      CALENDAR_GA_EVENT_ACTION.HotelFlightToggle,
      isHotelFlightsActive ? CALENDAR_GA_EVENT_LABEL.SetHotelFlights : CALENDAR_GA_EVENT_LABEL.SetHotel,
    )
  }, [onUserAnalyticsAction, dispatch])

  return <SwitchButton
    icon={<LinePlaneDepartureIcon />}
    checked={!!flights}
    onChange={handleChange}
    data-testid="flights-toggle"
  >
    {intl.formatMessage({
      id: 'ym_7F_8XeBafELPuHRKH',
      defaultMessage: 'Flights',
      description: 'Toggle label to include flights with hotel booking in calendar',
    })}
  </SwitchButton>
}

export default withOfferPageState((state) => ({
  flights: state.flights,
}), OfferCalendarFlightsToggle)
